import { Send, Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/siteData";

export const Footer = () => (
  <footer className="border-t border-teal-500/15 bg-[#080F22] py-16" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid gap-12 md:grid-cols-3">
      <div>
        <a href="#home" className="flex items-center gap-2" data-testid="footer-logo">
          <Send className="w-6 h-6 text-teal-400 -rotate-12" />
          <span className="font-serif text-2xl">
            <span className="text-white font-semibold">DX</span>
            <span className="text-teal-400">HOLIDAYS</span>
          </span>
        </a>
        <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
          Holiday packages, flight bookings and luxury bus tickets — crafted personally
          from Seawoods, Navi Mumbai.
        </p>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-[0.25em] text-teal-300 mb-5">Explore</h4>
        <nav className="flex flex-col gap-3 text-sm text-slate-400">
          <a href="#services" data-testid="footer-link-services" className="hover:text-teal-300 transition-colors">Services</a>
          <a href="#packages" data-testid="footer-link-packages" className="hover:text-teal-300 transition-colors">Packages</a>
          <a href="#films" data-testid="footer-link-films" className="hover:text-teal-300 transition-colors">DX Films</a>
          <a href="#contact" data-testid="footer-link-contact" className="hover:text-teal-300 transition-colors">Contact for Price</a>
        </nav>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-[0.25em] text-teal-300 mb-5">Reach us</h4>
        <div className="flex flex-col gap-4 text-sm text-slate-400">
          <a href={COMPANY.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-teal-300 transition-colors">
            <Phone className="w-4 h-4 text-amber-400 shrink-0" /> {COMPANY.phone}
          </a>
          <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-teal-300 transition-colors">
            <Mail className="w-4 h-4 text-amber-400 shrink-0" /> {COMPANY.email}
          </a>
          <p className="flex items-start gap-3" data-testid="footer-address">
            <MapPin className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
            <span>{COMPANY.address}</span>
          </p>
        </div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-600">
      <span data-testid="footer-copyright">© {new Date().getFullYear()} DXHOLIDAYS. All rights reserved.</span>
      <span>Crafted journeys, honest prices.</span>
    </div>
  </footer>
);

export default Footer;
